export * from './MoveTable';
export { default } from './MoveTable';
